import { useRouter } from "next/router";
import constants from "../utils/constants";
function useCheckViewerPage() {
  var _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  if (pathname.includes(constants.SCREENS.VIEWER)) {
    return true;
  }
  return false;
}
export default useCheckViewerPage;